import { withStyles } from '@mui/styles';
import { compose } from 'recompose';
import LoadingPage from './loading-page';
import { styles } from './loading-page.styles';

export default compose(withStyles(styles))(LoadingPage);
